export const productSeriesConf: Record<string, { productId: string; variantId: string }[]> = {
    jp: [
        {
            productId: '14797224509807',
            variantId: '52322658713967',
        },
        {
            productId: '14797224509807',
            variantId: '52261686018415',
        },
        {
            productId: '14797224509807',
            variantId: '52261686051183',
        },
        {
            productId: '14797224509807',
            variantId: '52322583970159',
        },
    ],
};
